function validateEmail(email: string): boolean {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}

function validatePostalCode(postalCode: string): boolean {
  if (!postalCode || typeof postalCode !== 'string') {
    return false;
  }

  const trimmed = postalCode.trim();

  // Universal postal code validation
  // Covers all countries from Sierra Leone (NN) to American Samoa (NNNNN-NNNNNN)
  // - Must start and end with alphanumeric (no leading/trailing space or dash)
  // - Can contain alphanumeric, space, or dash in the middle
  // - Length: 2-12 characters total
  const universalPostalRegex = /^[a-z0-9][a-z0-9\- ]{0,10}[a-z0-9]$/i;

  return universalPostalRegex.test(trimmed);
}

// Maintain backward compatibility with old function name
function validateZip(zip: string): boolean {
  return validatePostalCode(zip);
}

export default {
  validateEmail,
  validateZip,
  validatePostalCode,
};
